module.exports = __webpack_public_path__ + "static/img/img_login.f5b4d321.png";